<template>
    <div id="app">
        <el-container>
            <el-header>
                <div class="logo" @click="ToHomePage">
                    <img src="./assets/img/toplogo.png" style="height:3.5rem" />
                </div>
                <el-menu :default-active="defaultActive" class="el-menu-demo1" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="/intro" style="margin-left:2rem;">{{ $t('h.CompanyProfile') }}</el-menu-item>
                    <el-menu-item index="/histories">{{ $t('h.GrowthProcess') }}</el-menu-item>
                    <el-menu-item index="/product">{{ $t('h.MainBusiness') }}</el-menu-item>
                    <el-menu-item index="/case">{{ $t('h.BusinessData') }}</el-menu-item>
                    <el-menu-item index="/goin">{{ $t('h.CoreCompetitiveness') }}</el-menu-item>
                    <el-menu-item index="/about">{{ $t('h.ContactInformation') }}</el-menu-item>
                </el-menu>
                <div class="lang-dropdown">
                    <el-dropdown trigger="click" @command="handleCommand">
                        <span class="el-dropdown-link">{{ $t('h.system') }}<i
                                class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="ZH">中文</el-dropdown-item>
                            <el-dropdown-item command="EN">English</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <el-main>
                <router-view />
            </el-main>
            <div class="footer">
                <div class="footer-content" v-if="language == 'ZH'">
                    <span class="copyright">
                        <a style="color:#409eff;font-size:1rem;text-decoration:none;" target="_blank"
                            href="https://m-vue.tmgolf.cn/site/index">&nbsp;&nbsp;点此开启高尔夫之旅</a>
                        <a href="https://beian.miit.gov.cn" style="text-decoration:none;color:#999;margin-left: 20px;"
                            target="_blank">高坛技术 2024-2026 版权所有 粤ICP备2025490840号 </a>
                            <!-- <a href="https://beian.miit.gov.cn" style="text-decoration:none;color:#999;margin-left: 20px;"
                            target="_blank">铁马高尔夫 2004-2026 版权所有 粤ICP备2022109392号-1</a> -->

                    </span>
                    <span
                        style="font-family:'楷体';font-weight:bold;color:#999; letter-spacing: 2px;font-size:1.2rem;z-index:9999;">对未来最大的慷慨&nbsp;&nbsp;就是把一切献给现在</span>
                </div>
                <div class="en-footer-content" v-else>
                    <div class="en-footer-content-item">
                        <span class="copyright">
                            <div style="margin-top: 10px;">
                                <a style="color:#409eff;font-size:1rem;text-decoration:none;" target="_blank"
                                    href="https://m-vue.tmgolf.cn/site/index">Click here to start your golf journey</a>
                            </div>
                            <a href="https://beian.miit.gov.cn" style="text-decoration:none;color:#999;"
                                target="_blank">2024-2026 All rights reserved. Guangdong ICP Filing No. 09154164-3
                            </a>
                            <!-- <a href="https://beian.miit.gov.cn" style="text-decoration:none;color:#999;"
                                target="_blank">2004-2026 All rights reserved. Guangdong ICP Filing No. 2022109392-1
                            </a> -->

                        </span>
                    </div>
                    <div class="en-footer-content-item"
                        style="font-family:'楷体';font-weight:bold;color:#999; letter-spacing: 2px;font-size:.7rem;z-index:9999;">
                        The greatest generosity to the future is to devote everything to the
                        present moment.</div>
                </div>


            </div>
        </el-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            defaultActive: "",
            isShow: false,
            language: localStorage.getItem("lang") || "ZH"
        };
    },
    methods: {
        handleSelect(key) {
            this.defaultActive = key
            this.$router.push(key)
        },
        handleCommand(command) {
            if (command == "EN") {
                localStorage.setItem("locale", "en");
                this.$i18n.locale = localStorage.getItem("locale");
                localStorage.setItem("lang", "EN");
                this.language = "EN";
                location.reload(); //重新加载
            } else if (command == "ZH") {
                localStorage.setItem("locale", "zh");
                this.$i18n.locale = localStorage.getItem("locale");
                localStorage.setItem("lang", "ZH");
                this.language = "ZH";
                location.reload();
            }
        },
        ToHomePage() {
            this.$router.push("/")
             this.defaultActive = ""
        }

    },
    mounted() {
        localStorage.removeItem("showAnimation");
        const path = "/" + window.location.href.split("/#/")[1];
        this.defaultActive = path === "/" ? "" : path;
        this.language = localStorage.getItem("lang") || "ZH"
    },
};
</script>

<style>
* {
    padding: 0;
    margin: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

html,
body {
    min-width: 1200px;
    background: url(./assets/img/home_top.png) no-repeat center;
    background-size: cover;
    height: 100%;
    overflow: hidden;
}

#app {
    font-family: "宋体";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    padding-top: 25px;
}

.el-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 3.5rem;
    width: 100%;
}

.logo {
    width: 11.7rem;
}

.el-menu {
    background: none;
}

.el-header .el-menu .el-menu--horizontal {
    border: none;
}

.el-menu-demo1 {}

.el-menu-demo1 .el-menu-item {
    padding-right: 1.2rem;
    font-size: 1.2rem;
    font-weight: 600;
    margin-top: 0.7rem !important;
    color: #000 !important;
    border: none !important;
}


.el-menu-demo1 .el-menu-item.is-active {
    border: none !important;
    background: url(./assets/img/tab-icon.png) no-repeat center;
    background-size: 100% 100%;
    color: #fff !important;
}

.el-menu.el-menu--horizontal {
    border: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-main {
    padding: 0 !important;
    /* height: 750px; */
}

.footer {
    position: fixed;
    bottom: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 10px;
}

.footer-content {
    display: flex;
    justify-content: space-around;
    align-content: center;
    min-width: 1800px;
    overflow: hidden;
}

.en-footer-content {
    width: 100%;
    padding: 0 200px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-content: center;
    min-width: 1800px;
    overflow: hidden;
}

.en-footer-content-item {
    width: 45%;
}

.copyright {
    font-size: 0.8rem;
    text-align: left;
    z-index: 99999;
    font-family: "楷体";
    color: #999;
}

/* 独立语言切换 */
.lang-dropdown {
    display: flex;
    align-items: center;
    padding: 0 1.2rem;
    font-size: 1.2rem;
    font-weight: 600;
    margin-top: 0.7rem;
    color: #000;
}

.lang-dropdown .el-dropdown-link {
    cursor: pointer;
    color: #000;
    display: flex;
    align-items: center;
}

.el-icon-arrow-down {
    font-size: 12px !important;
}

.demonstration {
    display: block;
    color: rgb(23, 103, 254);
}
</style>
